import { all } from 'redux-saga/effects'

//public
import loginSaga from './auth/login/saga';
import forgetSaga from './auth/forgetpwd/saga';
import LayoutSaga from './layout/saga';
import UserSaga from './user/saga';
import RoleSaga from './role/saga';
import ProfileSaga from './profile/saga';
import GeneralSaga from './general/saga';
import DashboardSaga from './dashboard/saga';
import InquirySaga from './inquiry/saga';
import BranchSaga from './branch/saga';
import PermissionSaga from './permission/saga';
import ReuseableSettingSaga from './setting/saga';
import ServiceSaga from './service/saga';
import NotificationSaga from './notification/saga';
import DebitNoteSaga from './debitNote/saga';
import registerSaga from './auth/register/saga';
import SupportSaga from './support/saga';
import AdvertSaga from './advert/saga';
import AccessorySaga from './accessory/saga';
import LoanCalculateSaga from './loanCalculator/saga';
import CreditSaga from './credit/saga';
import InventorySaga from './inventory/saga';
import QuotationSaga from './quotation/saga';

export default function* rootSaga() {
        yield all([
                //public
                loginSaga(),
                registerSaga(),
                UserSaga(),
                GeneralSaga(),
                RoleSaga(),
                PermissionSaga(),
                ProfileSaga(),
                forgetSaga(),
                LayoutSaga(),
                DashboardSaga(),
                AdvertSaga(),
                AccessorySaga(),
                LoanCalculateSaga(),
                CreditSaga(),
                SupportSaga(),
                InventorySaga(),
                QuotationSaga(),

                DebitNoteSaga(),
                ServiceSaga(),
                NotificationSaga(),
                //Setting
                InquirySaga(),
                BranchSaga(),
                ReuseableSettingSaga(),
        ])
}